import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Tab } from '@mui/material';
import employeeApi from '../../components/common/employeeApi';

export default function StaffProgressOverview() {
  const [progresses, setProgresses] = useState([]);
  const [tab, setTab] = useState(0);

  useEffect(() => {
    employeeApi.get('/properties/progress/all/')
      .then(res => {

        res.data.forEach((item, idx) => {
        });
        setProgresses(res.data);
      })
      .catch(err => {
        console.error('Error fetching progress data:', err);
        setProgresses([]);
      });
  }, []);

  const grouped = {
    all: progresses,
    contacted: progresses.filter(p => (p.status || '').toLowerCase() === 'contacted'),
    signed: progresses.filter(p => (p.status || '').toLowerCase() === 'signed'),
    declined: progresses.filter(p => (p.status || '').toLowerCase() === 'declined'),
  };

  const tabLabels = [
    { label: 'All', key: 'all' },
    { label: 'Contacted', key: 'contacted' },
    { label: 'Signed', key: 'signed' },
    { label: 'Declined', key: 'declined' },
  ];
  const baseColumns = [
    { label: 'Student Email', key: 'user_email' },
    { label: 'Student Name', key: 'user_full_name' },
    { label: 'Property Address', key: 'rental_address' },
    { label: 'Company Name', key: 'rental_company_name' },
    { label: 'Property Title', key: 'rental_title' },
    { label: 'Property Contact Email', key: 'rental_contact_email' },
    { label: 'Status', key: 'status' },
  ];
  const withMoveInDate = [...baseColumns, { label: 'Move-in Date', key: 'move_in_date' }];
  const signedColumns = [...withMoveInDate, { label: 'Landlord Confirmed', key: 'landlord_confirmed' }, { label: 'Ad Fee', key: 'ad_fee_given' }];
  let columns;
  if (tabLabels[tab].key === 'signed') {
    columns = signedColumns;
  } else if (tabLabels[tab].key === 'all') {
    columns = withMoveInDate;
  } else {
    columns = baseColumns;
  }

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>Student Progress Overview</Typography>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 3 }}>
        {tabLabels.map((t, i) => <Tab key={t.key} label={t.label + ` (${grouped[t.key].length})`} />)}
      </Tabs>
      <Paper elevation={2}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {columns.map(col => <TableCell key={col.key}>{col.label}</TableCell>)}
              </TableRow>
            </TableHead>
            <TableBody>
              {grouped[tabLabels[tab].key].map((row, idx) => (
                <TableRow key={idx}>
                  {columns.map(col => (
                    <TableCell key={col.key}>
                      {col.key === 'move_in_date' && row[col.key] ? new Date(row[col.key]).toLocaleDateString() :
                       col.key === 'landlord_confirmed' ?
                         (row[col.key] ?
                           <span style={{ color: '#388e3c', fontWeight: 600 }}>✓ Confirmed</span> :
                           <span style={{ color: '#f57c00', fontWeight: 600 }}>✗ Pending</span>
                         ) :
                       col.key === 'ad_fee_given' ?
                         (row[col.key] ?
                           <span style={{ color: '#388e3c', fontWeight: 600 }}>Completed</span> :
                           <span style={{ color: '#f57c00', fontWeight: 600 }}>Pending</span>
                         ) :
                       row[col.key] || '-'}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
} 